import {
  resetPasswordInit,
  resetPasswordCreate,
  resetPasswordUpdate,
} from 'logic/member';

import { setNavType } from 'logic/theme';

export const ResetPassword = {
  template: `
    <div class="login" ng-hide="$ctrl.auth.token">
      <div class="main-content theme-mid pt-4">
        <div class="container align-items-center justify-content-center pb-5">
          <header class="text-center pt-2 pb-4">
            <divider-zig-zag>
              <h1 class="h2 text-white">
                Reset your Password
              </h1>
            </divider-zig-zag>
          </header>
          <div class="row mb-4">
            <div class="col-lg-6 mx-auto px-2 px-sm-0">
              <section class="p-3 theme-light">
                <div class="container px-3 px-lg-4 pt-5 pb-3 bg-white">
                  <div scroll-top-on-change="$ctrl.member.message">
                    <alert type="{{ $ctrl.member.error ? 'danger' : 'success' }}"
                      ng-if="$ctrl.member.message">
                      {{ $ctrl.member.message }}
                    </alert>
                  </div>
                  <form-reset-password
                    ng-if="!$ctrl.isUpdate"
                    email="$ctrl.email"
                    member="$ctrl.member"
                    on-submit="$ctrl.resetPasswordCreate(data)">
                  </form-reset-password>
                  <form-reset-password
                    ng-if="$ctrl.isUpdate"
                    is-update="$ctrl.isUpdate"
                    email="$ctrl.email"
                    member="$ctrl.member"
                    reset-password-token="$ctrl.resetPasswordToken"
                    on-submit="$ctrl.resetPasswordUpdate(data)">
                  </form-reset-password>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>`,

  controller($ngRedux, $stateParams) {
    'ngInject';

    return {
      $onInit() {
        const connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.unsubscribe = connect(this);

        this.email = $stateParams.email;
        this.resetPasswordToken = $stateParams.reset_password_token;
        this.isUpdate = this.email && this.resetPasswordToken;

        // Use the plain nav so member can't navigate.
        this.setNavType('plain');

        // Reset the form when there are no $stateParams
        if (!this.email && !this.resetPasswordToken) {
          this.resetPasswordInit();
        }
      },

      $onDestroy() {
        this.unsubscribe();
      },

      mapState({ member }) {
        return { member };
      },

      mapDispatch() {
        return {
          resetPasswordInit,
          resetPasswordCreate,
          resetPasswordUpdate,
          setNavType,
        };
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/containers/ResetPassword.js